import Button from "@app/components/button";
import { Images } from "@assets/images";
import { PortalDialogProps } from "@app/services/modal.service";
import Modal from "../modal/modal.component";
import clsx from "clsx";
import { CategoryV2 } from "@app/types";
import { useState } from "react";
import { SystemMessage } from "@app/constants";

interface CategoryModalProps {
  categoryIds: number[];
  categories: CategoryV2[];
}

function CategoryModal({
  portalDialogRef,
  portalData,
}: PortalDialogProps<CategoryModalProps>) {
  const [selectionIds, setSelectionIds] = useState<number[]>(
    portalData?.categoryIds ?? []
  );
  const [error, setError] = useState("");

  const handleItemClick = (categoryId: number) => {
    const newSelectionIds = [...selectionIds];

    const index = newSelectionIds.indexOf(categoryId);

    if (index !== -1) {
      newSelectionIds.splice(index, 1);
    } else {
      newSelectionIds.push(categoryId);
    }

    setSelectionIds(newSelectionIds);
  };

  const handleSubmit = () => {
    if (!selectionIds.length) {
      setError(SystemMessage.SELECT_CATEGORY_REQUIRED);

      return;
    }

    portalDialogRef.close({ categorySelectionIds: selectionIds });
  };

  return (
    <Modal onCancel={portalDialogRef.close} buttonCancelInChildren={false}>
      <div className="flex items-center justify-center">
        <div className="w-[463px] h-auto px-[34px] py-10 bg-white rounded-xl">
          <div className="flex justify-center">
            <img className="w-28" src={Images.LogoText.default} alt="" />
          </div>
          <div className="mt-3 black-30 text-sm text-center font-[SVN-Gilroy] font-medium">
            Hãy chọn chủ đề yêu thích của bạn để bắt đầu
          </div>
          <div className="mt-12 text-[#171A20] font-[SVN-Gilroy] font-semibold text-lg">
            Yêu thích
          </div>
          <div className="flex flex-wrap gap-[10px] mt-3">
            {!!portalData?.categories?.length &&
              portalData.categories.map((item, index) => (
                <div
                  key={index}
                  className={clsx(
                    "py-2 px-4 rounded-xl text-sm font-[SVN-Gilroy] tracking-[0.028px] font-medium",
                    "cursor-pointer border border-solid border-[#D5DBE2] hover:bg-gray-300 select-none",
                    {
                      "text-white bg-[#5A82D7] hover:bg-[#6d94e9]":
                        selectionIds.includes(item.id),
                    }
                  )}
                  onClick={() => handleItemClick(item.id)}
                >
                  {item.name}
                </div>
              ))}
          </div>
          {!!error && <div className="mt-2 error-color text-xs">{error}</div>}
          <Button
            containerClassName="mt-12 mx-auto"
            label="Bắt đầu"
            labelClassName="font-[SVN-Gilroy]"
            width=""
            size="l"
            className="text-lg bg-gradient-to-b from-[#5A82D7] to-[#4667CA] font-bold rounded-[26px] hover:!bg-[#6d94e9]"
            onClick={handleSubmit}
          />
        </div>
      </div>
    </Modal>
  );
}

export default CategoryModal;
